import React, {useState, useRef, useEffect} from 'react';
import ReactFlow, {addEdge, removeElements, Controls, useStoreState } from 'react-flow-renderer';
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import RfEditorSidebar from './Sidebar';
import { useDispatch, useSelector } from "react-redux";
import { currentStep, addStep, setSteps } from "../redux/slices/step/stepSlice";
import { connect } from 'react-redux';

// const initialElements = [
//   { id: '0', type: "input", data: { label: 'Start' }, position: { x: 0, y: 5 } },
//   // you can also pass a React component as a label
//   { id: '1', data: { label: <div>Node 2</div> }, position: { x: 0, y: 100 } },
//   { id: 'e1-2', source: '0', target: '1', animated: true, label: 'test'},
// ];


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
    Width: "100%",
  },
}));


function EditorReactFlow(props) {
  const dispatch = useDispatch();
  let datetime = (new Date().toLocaleDateString() + new Date().toLocaleTimeString())
  const getId = () => { return datetime}; //raises ID each time its called, its used for when nodes/panes are added
  const classes = useStyles();
  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const product_id = props.id //gets ID from props


  // console.log(useStoreState((state) => state.selectedElements), "store updated?")
  // useEffect(() => {
  //   console.log(useStoreState((state)=> state.selectedElements), "store updated")
  // })


  // let elements = props.todos.data;  // Redux passes elements list through props
  const elements = useSelector(state => state.step.data)  // Redux passes elements list through props

  const onConnect = (params) => { 
    // Here, addEdge should be a Redux action, and needs to be dispatched
    const arr = addEdge(params, elements); //lets addEdge create the element (node connection) and returns it inside array with elements
    const edge = arr[arr.length - 1] //gets the last added element, which is the connection
    dispatch(addStep({element: edge}));
  };

  const onElementsRemove = (elementsToRemove) => {
    // Here, removeElementsshould be a Redux action, and needs to be dispatched
    // elementsToRemove.forEach(element => {
    //   const data = {product: product_id, element: element}
    //   dispatch(deleteStep(data))      
    // });
    const removedElement = removeElements(elementsToRemove, elements)
    dispatch(setSteps(removedElement));
  };

  const onLoad = (_reactFlowInstance) =>{
    _reactFlowInstance.fitView();
    setReactFlowInstance(_reactFlowInstance);}
    // dispatch(setSteps(_reactFlowInstance));}

  // const onSave = useCallback((reactFlowInstance) => {
  //   console.log(reactFlowInstance, props)
  //   if (reactFlowInstance) {
  //     const flow = reactFlowInstance
  //     console.log(flow)
  //     // const data = {flow, slug};
  //     // dispatch(editProduct(data));
  //   }
  // }, [reactFlowInstance, dispatch, slug, elements]);

  const onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  };

  const onNodeDragStop = (event) =>{
    dispatch(setSteps(reactFlowInstance.toObject().elements))
  }

  const onDrop = (event) => {
    event.preventDefault();
    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const type = event.dataTransfer.getData('application/reactflow');
    const position = reactFlowInstance.project({
      x: event.clientX - reactFlowBounds.left,
      y: event.clientY - reactFlowBounds.top,
    });
    const newNode = {product: product_id, element: {
      id: `${getId()}`,
      type,
      position,
      data: { label: `${type} node` },
    }};
    dispatch(addStep(newNode));
    ///dispatch to step slice, create state +1 with new ID and product ID integrated, after clicking save, send to DB with completed assembly steps
  };

  const onElementClick = (event, element) => {
    dispatch(currentStep(element.id))
  }


  return (
    <Container maxWidth="lg">
      <CssBaseline />
      <div className={classes.paper}> </div>
      <div className="{classes.heroContent} reactflow-wrapper" ref={reactFlowWrapper}>
          <ReactFlow 
            elements={elements} 
            onElementsRemove={onElementsRemove}
            style={{width:'100%',height: '90vh'}}
            onLoad={onLoad}
            onConnect = {onConnect}
            onDrop={onDrop}
            onDragOver={onDragOver}
            onElementClick={onElementClick}
            onNodeDragStop={onNodeDragStop}
            snapToGrid={true}
            maxZoom={8}
            >            
            <Controls props={props}/> 
          </ReactFlow>
          {/* <button onClick={onSave}>save</button> */}
      </div>
      <RfEditorSidebar />
    </Container>
  );
}

export default connect(
  // Ask Redux to pass Redux state to "props.todos"
  // According to your "addStep" reducer, elements are stored as "state.data"
  // So, elements list will be passed as "props.step.data"
  (state) =>[{ step: state.step }]  
)(EditorReactFlow);